<script lang='ts' setup>

</script>
<template>
    <div>
        <div>关于我们....</div>
    </div>
</template>
<style lang='scss' scoped>
</style>